module.exports = __webpack_public_path__ + "img/SCBT.07e83507.png";